import React from 'react';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import Table from './GrowerYieldGrid';
import Map from './YieldMap';
import { Section } from '../Section';
import { YieldContext } from './context.jsx';

export default function GrowerYield() {
  return (
    <Section>
      <YieldContext>
        <ResizablePanel topPanel={<Map />} bottomPanel={<Table />} />
      </YieldContext>
    </Section>
  );
}
